import React, { useRef } from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import usePagination from "../../../components/Pagination";
import constantService from '../../../services/constant';
import ordersSingleService from "../../../services/orderSingleFix";
import MenuApp from '../../../components/Menu';
import AuthService from "../../../services/security/auth.service";
import { ThemeProvider } from '@mui/material/styles';
import constantsDesign from '../../../utils/constants';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';

const SystemPages = ({ instance }) => {
    let navigate = useNavigate();
    const [list, setList] = useState([]);
    const [load, setLoad] = useState(true);
    const [listSegmentSize, setListSegmentSize] = useState('');
    const [page, setPage] = React.useState(1);
    const PER_PAGE = listSegmentSize;
    const count = Math.ceil(list.length / PER_PAGE);
    const _DATA = usePagination(list, PER_PAGE);
    const boxRef = useRef(null);

    const handleChangePagination = (event, value) => {
        setPage(value);
        _DATA.jump(value);
    };

    useEffect(() => {

        setLoad(true);
        const user = AuthService.getCurrentUser();
        console.log('user-> ' + JSON.stringify(user))
        ordersSingleService.getOrders(user.client, user.data.instance).then((response) => {

            let arrayInitialList = [];
           
            for (let i = 0; i < response.data.length; i++) {
                arrayInitialList.push(response.data[i]);
            }
            setList(arrayInitialList);
            if (user) {
                constantService.viewConstantsFindAll(user.client, user.data.instance).then((response) => {
                   
                    setListSegmentSize(response.data.constants.listSegmentSize.value)
                    setLoad(false);
                }).catch((error) => {
                    console.log("error" + error);
                    setLoad(false);
                });
            } else {
                setLoad(false);
            }
        }).catch((error) => {
            console.log(error);
        });
    }, []);


    const buttonFieldsActionList = (id) => {
        setLoad(true);
        navigate(`/newOrderFix?id=${id}`);
    }

    return (
        <ThemeProvider theme={constantsDesign.CUSTOM_MUI_GENERAL_THEME}>
            <div className="App">
                <CssBaseline />
                <header className="App-header">
                    <Box ref={boxRef} sx={{ width: "100%", flexGrow: 1 }}>
                        <Grid container xs={12} item>
                            <Grid container sx={{ m: 1 }} xs={12} item>
                                <ThemeProvider theme={constantsDesign.CUSTOM_MUI_TEXT_FIELD_THEME}>
                                    <Box sx={{ width: '100%' }}>
                                        <MenuApp />
                                        <br></br>
                                        
                                        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
                                            Órdenes FIX
                                        </Typography>
                                        <Button variant='outlined' onClick={() => navigate('/newOrderFix')}>Crear órden</Button>

                                        {load && (
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <CircularProgress size={150} />
                                            </div>
                                        )}
                                        {!load && (
                                            <div>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 650, height: '100%' }} aria-label="simple table">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell ></TableCell>
                                                                <TableCell >ClOrdID</TableCell>
                                                                <TableCell >Symbol</TableCell>
                                                                <TableCell >Account</TableCell>
                                                                <TableCell >SecurityID</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {
                                                                _DATA.currentData().map((row) => {
                                                                    console.log('row-> ' + JSON.stringify(row))
                                                                    return (
                                                                        <TableRow key={row.id}
                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                        >

                                                                            <TableCell component="th" scope="row" width={7}>
                                                                                <Button onClick={() => buttonFieldsActionList(row.id)}>
                                                                                    <VisibilityIcon />
                                                                                </Button>
                                                                            </TableCell>
                                                                            <TableCell>{row.fields.clOrdID}</TableCell>
                                                                            <TableCell>{row.fields.symbol}</TableCell>
                                                                            <TableCell>{row.fields.account}</TableCell>
                                                                            <TableCell>{row.fields.securityID}</TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <Stack spacing={2} width={'100%'}>
                                                    <Pagination count={count} page={page} color="primary" onChange={handleChangePagination} />
                                                </Stack>
                                            </div>
                                        )}
                                    </Box>
                                </ThemeProvider>
                            </Grid>
                        </Grid>
                    </Box>
                </header>
            </div>
        </ThemeProvider>
    )
}

export default SystemPages